import { Row, Col, Card, Skeleton, Avatar, Typography, Image, List, Tag, Descriptions } from "antd";
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import apiPath from "../../../constants/apiPath";
import moment from 'moment';
import { formatDate } from "../../../helper/DateHelper";
const { Title, Text } = Typography;

function View() {
  const params = useParams();
  const { request } = useRequest();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = (user_id, id) => {
    setLoading(true);
    request({
      url: apiPath.commonBrand,
      method: 'POST',
      data: { id, user_id },
      onSuccess: (response) => {
        setLoading(false);
        setData(response.data);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      }
    });
  };

  useEffect(() => {
    fetchData(params.user_id, params.id);
  }, []);

  if (loading) return <Skeleton active />;

  return (
    <Row gutter={16}>
      
      <Col span={24}>
        
        <Card title={data?.name || 'Brand Details'}>
          <Image src={data?.logo} alt="Brand Logo" width={100} />

          <Descriptions column={1}>
            <Descriptions.Item label="Category">{data?.category_id?.name}</Descriptions.Item>
            <Descriptions.Item label="City">{data?.city_id?.name}</Descriptions.Item>
            <Descriptions.Item label="Description">{data?.short_description}</Descriptions.Item>
            <Descriptions.Item label="Contact Details">
              {data?.contact_detail.map((contact) => (
                <div key={contact.label}>{contact.label}: {contact.value}</div>
              ))}
            </Descriptions.Item>
            <Descriptions.Item label="Tags">
              {data?.tag_id.map((tag) => (
                <Tag key={tag._id}>{tag.title}</Tag>
              ))}
            </Descriptions.Item>
            <Descriptions.Item label="Remark">{data?.remark}</Descriptions.Item>
            <Descriptions.Item label="Images">{data?.images}</Descriptions.Item>

            <Descriptions.Item label="Created On">{formatDate(data?.created_at)}</Descriptions.Item>
          </Descriptions>

          <div className="view-inner-cls float-right">
            <Link className="ant-btn ant-btn-primary" to={`/user/service-product/${params.user_id}`}>Back</Link>
          </div>
          
        </Card>
      </Col>

      <Col span={24} className="mt-2">
        <Row gutter={24}>
          {data?.psl_list.map((bucket) => (
            <Col md={12}>
              <Card key={bucket._id} title={bucket.psl_name} className="mt-4">
                {bucket.ps_list.map((service) => (
                  <Card key={service._id} type="inner" title={service.ps_name}>

                    <div className="mb-2">
                      <strong>Remark</strong>: <span className="cap"> {service?.remark || 'N/A'} </span>
                    </div>
                    
                    <div className="mb-1">

                      <strong>Images</strong>: 

                      {service?.images?.length > 0 ? (
                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                          {service.images.map((image, index) => (
                            <Image
                              key={index}
                              src={image}
                              width={100}
                              height={100}
                              style={{ objectFit: "cover", borderRadius: "6px" }}
                              alt={`Image ${index + 1}`}
                            />
                          ))}
                        </div>
                      ) : (
                        <Text>No images available</Text>
                      )}
                    </div>

                    <List
                      dataSource={service.psla_list}
                      renderItem={(item) => (
                        <List.Item>
                          <strong>{item.psla_label}</strong>: {item.psla_value || 'N/A'}
                        </List.Item>
                      )}
                    />
                  </Card>
                ))}
              </Card>
            </Col>
          ))}
        </Row>
      </Col>
      
    </Row>
  );
}

export default View;